module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('h4', [_vm._v("Status: "), _c('span', [_vm._v(_vm._s(_vm.user && _vm.user.premium ? 'Premium' : 'Free'))])]), _vm._v(" "), (!_vm.user || !_vm.user.premium) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks!")]) : _vm._e(), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/changepassword'
      }
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Email:\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v("\n      Pick Notifications:\n      "), _c('form', {
    staticStyle: {
      "padding-left": "2px",
      "display": "inline"
    },
    attrs: {
      "name": "form1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact_method),
      expression: "user.contact_method"
    }],
    attrs: {
      "type": "radio",
      "name": "contactMethod"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.contact_method, 0)
    },
    on: {
      "change": function($event) {
        _vm.methodChanged()
      },
      "__c": function($event) {
        _vm.user.contact_method = 0
      }
    }
  }), _vm._v(" None\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact_method),
      expression: "user.contact_method"
    }],
    attrs: {
      "type": "radio",
      "name": "contactMethod"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.contact_method, 1)
    },
    on: {
      "change": function($event) {
        _vm.methodChanged()
      },
      "__c": function($event) {
        _vm.user.contact_method = 1
      }
    }
  }), _vm._v(" Email\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact_method),
      expression: "user.contact_method"
    }],
    attrs: {
      "type": "radio",
      "name": "contactMethod"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.user.contact_method, 2)
    },
    on: {
      "change": function($event) {
        _vm.methodChanged()
      },
      "__c": function($event) {
        _vm.user.contact_method = 2
      }
    }
  }), _vm._v(" Text Message\n      "), (_vm.user.contact_method === 2) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "phones",
      "id": "phoneList"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.phone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.phoneOpts), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p.key))])
  })) : _vm._e(), _vm._v(" "), (_vm.user.contact_method !== 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contact_email),
      expression: "user.contact_email"
    }],
    attrs: {
      "type": "text",
      "name": "contact_email",
      "placeholder": _vm.user.contact_method === 1 ? 'Enter Contact Email' : 'Enter Contact Phone',
      "id": "contactEmail"
    },
    domProps: {
      "value": (_vm.user.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.contact_email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("Save")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dbf5e4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyAccount.vue
// module id = 296
// module chunks = 1